import { useEffect, useState } from 'react';

const MOBILE_BREAK_POINT = 768;

const useMobileView = () => {
  const query = `(max-width: ${MOBILE_BREAK_POINT - 1}px)`;

  const [isMobileView, setIsMobileView] = useState(
    () => (typeof window !== 'undefined' ? window.matchMedia(query).matches : false),
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    const handleChange = (event) => setIsMobileView(event.matches);

    mediaQuery.addEventListener('change', handleChange);
    setIsMobileView(mediaQuery.matches);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, [query]);

  return isMobileView;
};

export default useMobileView;
